import React from 'react';
import { withErrorBoundary } from '../ErrorBoundary';
import { withInjectedProps } from '../InjectedPropsContext';

type FieldLabelTextProps = {
  name?: string;
  label?: string;
};

/**
 * Component that returns a user friendly name for a field.
 * Will try to obtain a label from prop-injection.
 * Where a label cannot be obtained, we will return the path-name as a last resort.
 *
 * Note this component will only work on fields where labels are injected by name
 * (i.e. worksheets where labels have been migrated to config)
 *
 * TODO: We may in future need to provide more context for where the field
 * is in the data structure (possibly by properties on the "parent" obejcts in its path)
 */
const FieldLabelTextBase: React.FC<FieldLabelTextProps> = ({ label, name }) => (label as any) ?? name ?? null;

const FieldLabelText = withErrorBoundary(withInjectedProps(FieldLabelTextBase));

export { FieldLabelText };
export default FieldLabelText;
